import React, { useEffect } from "react";
import { useParams, Link } from "react-router-dom";
import { motion, useScroll, useSpring } from "framer-motion";
import { Helmet } from "react-helmet-async";
import { getBlogBySlug } from "../data/blogs";
import "./Blog.css"; // Ensure your CSS is linked

export default function BlogDetail() {
  const { slug } = useParams();
  const blog = getBlogBySlug(slug);
  const { scrollYProgress } = useScroll();
  const scaleX = useSpring(scrollYProgress, { stiffness: 100, damping: 30 });
  // --- ADD THIS SHARING LOGIC ---
  const shareUrl = window.location.href;
  const shareTitle = blog ? blog.title : "Check out this technical insight from ITSeva Hub";

  const handleShare = (platform) => {
    let url = "";
    if (platform === "linkedin") {
      url = `https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(shareUrl)}`;
    } else if (platform === "twitter") {
      url = `https://twitter.com/intent/tweet?url=${encodeURIComponent(shareUrl)}&text=${encodeURIComponent(shareTitle)}`;
    }
    window.open(url, "_blank", "width=600,height=400");
  };
  // ------------------------------

  useEffect(() => { window.scrollTo(0, 0); }, [slug]);

  if (!blog) return <div className="error">Article Not Found</div>;

  return (
    <div className="blog-page-v2">
      <Helmet>
        <title>{blog.title} | ITSeva Hub</title>
        <meta name="description" content={blog.desc} />
      </Helmet>

      {/* Progress Bar for Reading */}
      <motion.div className="progress-bar" style={{ scaleX }} />

      <header className="detail-header">
        <div className="header-container">
          <Link to="/blog" className="back-to-insights">← Back to Insights</Link>
          <div className="title-section">
             <span className="category-pill">{blog.category}</span>
             <h1>{blog.title}</h1>
             <div className="card-meta">By ITSeva Engineering • {blog.date} • {blog.readTime}</div>
          </div>
        </div>
      </header>

      {/* NEW GRID LAYOUT */}
      <main className="article-layout-grid">
        <div className="content-column">
          <motion.img 
            initial={{ opacity: 0, y: 20 }} 
            animate={{ opacity: 1, y: 0 }}
            src={blog.image} 
            alt={blog.title} 
            className="featured-img" 
          />
          
          {blog.summary && (
            <div className="takeaways-box">
              <h3>Key Takeaways</h3>
              <ul>
                {blog.summary.map((point, i) => <li key={i}>{point}</li>)}
              </ul>
            </div>
          )}

          <div 
            className="rich-text-content"
            dangerouslySetInnerHTML={{ __html: blog.content }} 
          />
        </div>

        {/* --- ADDED SIDEBAR --- */}
           <aside className="article-sidebar">
      <div className="sticky-cta">
        <div className="cta-icon">🚀</div>
        <h4>Partner with ITSeva Hub</h4>
        <p>Expert consulting for NetSuite, Salesforce, and Enterprise Development.</p>
        <Link to="/contact" className="sidebar-btn">Get a Technical Audit</Link>
        
        {/* UPDATED BUTTONS WITH ONCLICK */}
        <div className="sidebar-footer-links">
          <span>Share:</span>
          <button 
            className="icon-link" 
            onClick={() => handleShare("linkedin")}
          >
            LinkedIn
          </button>
          <button 
            className="icon-link" 
            onClick={() => handleShare("twitter")}
          >
            Twitter
          </button>
        </div>
      </div>
    </aside>
      </main>
    </div>
  );
}